import { Component, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  constructor() {
    // Keep crawlers off non-prod sites.
    if (environment.noFollow) inject(Meta).addTag({ name: 'robots', content: 'noindex, nofollow' });
  }
}
